export enum SubscriptionStatus {
  Active = 'Active',
  Pause = 'Pause',
  Terminated = 'Terminated',
}
